import { render, staticRenderFns } from "./DashboardComponent.vue?vue&type=template&id=32cc6099&scoped=true&"
import script from "./DashboardComponent.vue?vue&type=script&lang=js&"
export * from "./DashboardComponent.vue?vue&type=script&lang=js&"
import style0 from "./DashboardComponent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DashboardComponent.vue?vue&type=style&index=1&id=32cc6099&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cc6099",
  null
  
)

export default component.exports